export const SUPPORTED_PLATFORMS = [
  { osId: 1, name: 'Android', iconSrc: '/sotixsight/get-resource/assets/images/AndroidIcon.svg' },
  {
    osId: 2,
    name: 'Windows',
    iconSrc: '/sotixsight/get-resource/assets/images/WindowsIcon.svg',
  },
];

// Linux agents are not fully supported yet, so we allow to generate them,
// but do not allow to select Linux as a target OS in Profiles
export const AGENT_PLATFORMS = [
  ...SUPPORTED_PLATFORMS,
  {
    osId: 4,
    name: 'Linux',
    iconSrc: '/sotixsight/get-resource/assets/images/LinuxIcon.svg',
  },
];

export enum PlatformType {
  ANDROID = 1,
  WINDOWS = 2,
  LINUX = 4,
}

export const AllPlatforms = -1;
